<template>
  <div class="wrapper-scheda-paziente">
    <div class="column-scheda-paziente-first">
      <div class="sa-badge">
        <div class="sa-badge-data-width-100 mb-2">
          <span class="sa-badge-label"><i class="fas fa-universal-access fa-2x text-muted"></i></span>
          <span class="sa-badge-data">{{ jsonData.accettazione.statoAttuale }}</span>
        </div>
        <div class="sa-avatar-wrapper">
          <img v-if="jsonData.accettazione.accettazioneAnagrafica.sesso === 'M'" src="@/assets/images/ico_m.png" />
          <img v-else src="@/assets/images/ico_f.png" />
        </div>
        <div class="sa-badge-data-width-100 mb-2">
          <span class="sa-badge-label"><i class="fas fa-user fa-2x text-muted"></i></span>
          <span class="sa-badge-data">{{ jsonData.accettazione.accettazioneAnagrafica.cognome }} {{
            jsonData.accettazione.accettazioneAnagrafica.nome }}</span>
        </div>
        <hr />
        <div class="sa-badge-data-width-100">
          <span class="sa-badge-label"><i class="fas fa-id-card fa-2x text-muted"></i></span>
          <span class="sa-badge-data">{{ jsonData.accettazione.accettazioneAnagrafica.identificativo }}</span>
        </div>
      </div>
    </div>

    <div class="column-scheda-paziente-second">
      <div class="sa-pill-container">
        <div class="sa-pill-tab-wrapper">
          <div v-for="tab in tabs" :key="tab" class="sa-pill-tab-element"
            :class="{ 'sa-pill-active': currentTab === tab }" @click="setTab(tab)">
            {{ tab }}
          </div>
        </div>
        <div class="sa-pill-view">
          <div class="sa-pill-view-header">
            TODO
          </div>
          <div class="sa-pill-view-body">
            <transition name="fade-slide" mode="out-in">
              <div class="sa-tab-wrapper" :key="currentTab">
                <template v-if="currentTab === 'IMPEGNATIVE'">
                  <AccettazioneSsnImpegnativaComponent1 />
                </template>
                <template v-if="currentTab === 'ANAGRAFICA'">
                  <AccettazioneSsnAnagraficaComponentN :isEdit="isEdit"
                    @changeJsonData="onChangeAccettazioneAnagraficaJSON" @beforeLoadData="onBeforeLoadData"
                    @afterLoadData="onAfterLoadData" />
                </template>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="column-scheda-paziente-third">
      <div class="sa-pill-container">
        <div class="sa-pill-view">
          <div class="sa-pill-view-header">
            TODO
          </div>
          <div class="sa-pill-view-body">
            <TimelineComponent :items="appuntamentiProssimi" :maxHeight="500" />
          </div>

        </div>
      </div>
      <div class="sa-side-section">
        <div class="sa-side-header">Appuntamenti</div>
        <div class="sa-side-body">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityMixin from '../../../utility/UtilityMixin';
import TimelineComponent from "../../../../template/components/utility/TimelineComponent.vue"
import AccettazioneSsnAnagraficaComponentN from "../components/AccettazioneSsnAnagraficaComponentN.vue"
import AccettazioneSsnImpegnativaComponent1 from "../components/AccettazioneSsnImpegnativaComponent1.vue"
export default {
  mixins: [UtilityMixin],
  components: { TimelineComponent, AccettazioneSsnAnagraficaComponentN, AccettazioneSsnImpegnativaComponent1 },
  data() {
    return {
      id: null,
      currentTab: 'IMPEGNATIVE',
      tabs: ['IMPEGNATIVE', 'ANAGRAFICA'],
      appuntamentiProssimi: [
        { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' }, { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' },
      ],
      jsonData: {
        accettazione: {
          statoAttuale: 'In Attesa',
          accettazioneAnagrafica: { nome: 'Mario', cognome: 'Rossi', identificativo: 'ID-123', sesso: 'M' }
        }
      }
    }
  },
  methods: {
    setTab(tabName) { this.currentTab = tabName; }
  }
}
</script>

<style scoped>
.wrapper-scheda-paziente {
  display: flex;
  width: 100%;
  height: 100vh;
  padding: 10px;
  gap: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.column-scheda-paziente-first,
.column-scheda-paziente-third {
  flex: 0.3;
}

.column-scheda-paziente-second {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.sa-pill-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* Forza altezza */
  min-height: 0;
  overflow: hidden;
}

.sa-pill-tab-wrapper {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding-bottom: 10px;
  flex-shrink: 0;
  /* Non si rimpicciolisce */
}

.sa-pill-view {
  background: #ffffff;
  border-radius: 14px;

  border: 1px solid #e3eceb;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: 600px;
  min-height: 0;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
}

.sa-pill-view-header {
  padding: 14px 18px;
  background: linear-gradient(90deg, #f0faf8, #ffffff);
  border-bottom: 1px solid #e3eceb;
  color: #1e6f65;
  flex-shrink: 0;
}

.sa-pill-view-body {
  padding: 16px;
  flex-grow: 1;
  overflow-y: auto;
  min-height: 0;
  background: #ffffff;
  border-top-left-radius: 1px;
  border-left: 4px solid var(--bg-main-nav-bar);

  padding: 7px !important;
}

.sa-tab-wrapper {}

/* Resto degli stili invariato */
.sa-field {
  display: flex;
  flex-direction: column;
  background: #f9fcfc;
  border: 1px solid #e4f1ef;
  border-radius: 10px;
  padding: 10px 12px;
  margin: 5px;
  box-sizing: border-box;
}

.sa-field-wrapper {
  background: #f9fcfc;
  border: 1px solid #e4f1ef;
  border-radius: 10px;
  padding: 10px 12px;

}

.sa-field .label {
  font-size: 10px;
  font-weight: 600;
  color: #6b8f8b;
  text-transform: uppercase;
}

.sa-field .value {
  font-size: 13px;
  font-weight: 600;
  color: #243c3a;
  margin-top: 2px;
}

.sa-pill-tab-element {
  padding: 8px 20px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 100px;
  background-color: #f0faf8;
  color: #6b8f8b;
  border: 1px solid #e4f1ef;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sa-pill-active {
  background-color: #1e6f65 !important;
  color: #ffffff !important;
  border-color: #1e6f65 !important;
}

.sa-avatar-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 15px 0;
}



/* Animazioni */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(15px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>